import { IconButton } from '@saucelabs/ds-button';
import { IconChevronLeftFill, IconChevronRightFill } from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import React from 'react';
import { useHistory } from 'react-router';

import { BuildFragFragment, DiffViewFragmentFragment, DiffsOrderBy } from '../../graphql/__generated__/graphql';
import { urls } from '../../routes';
import KeyBind from '../common/KeyBind';

type Props = {
  build: Exclude<BuildFragFragment, undefined | null>,
  diffView: DiffViewFragmentFragment;
  diffOrder: DiffsOrderBy;
}

const DiffHeaderNav: React.FC<Props> = ({ build, diffView, diffOrder }) => {
  const history = useHistory();
  const diffCount = build.diffIds.nodes.length;

  const visitPage = (step: string) => history.push(
    urls.getDiff(build.id, step, { order: diffOrder }),
  );
  const currentIndex = build.diffIds.nodes.findIndex((node) => node.id === diffView.id);
  const prevPage = () => {
    if (currentIndex > 0) {
      visitPage(build.diffIds.nodes[currentIndex - 1].id);
    }
  };
  const nextPage = () => {
    if (currentIndex !== diffCount - 1) {
      visitPage(build.diffIds.nodes[currentIndex + 1].id);
    }
  };

  return (
    <div className="flex py-3">
      <KeyBind
        char="ArrowLeft"
        displayChar="←"
        func={prevPage}
        label="Previous Snapshot"
      >
        <IconButton
          aria-label="Previous Snapshot"
          icon={<IconChevronLeftFill />}
          isDisabled={currentIndex <= 0}
          onPress={prevPage}
          variant="text"
        />
      </KeyBind>
      <Typography
        className="text-medium-emphasis text-base flex items-center px-1 tracking-wider font-normal"
        variant="body-large"
      >
        {currentIndex + 1}
        /
        {diffCount}
      </Typography>
      <KeyBind
        char="ArrowRight"
        displayChar="→"
        func={nextPage}
        label="Next Snapshot"
      >
        <IconButton
          aria-label="Next Snapshot"
          icon={<IconChevronRightFill />}
          isDisabled={currentIndex === diffCount - 1}
          onPress={nextPage}
          variant="text"
        />
      </KeyBind>
    </div>
  );
};

export default DiffHeaderNav;
